import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles({
  root: {
    padding: '5px !important',
    color: 'black',
  },
});
